import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    boo: false,
    userContent: {
      page: 1,
      pageSize: 10,
      account: '',
      status: null,
      departmentId: '',
      isDy: false
    },
    tableData: [],
    total: null
  },
  mutations: {
    changeUserContent (state, data) {
      state.userContent = data
    },
    change (state) {
      state.boo = !state.boo
    },
    userPageSize (state, value) {
      state.userContent.pageSize = value
    },
    userPage (state, value) {
      state.userContent.page = value
    },
    userTableData (state, arr) {
      state.tableData = arr
    },
    userTotal (state, value) {
      state.total = value
    }
  },
  actions: {
  },
  modules: {
  }
})
